import { Typography } from "@mui/material"
import { BasicHeaderWrapper } from "./Atom"

const OpportunityHeader = (props: { headerName: string; width?  : string }) => {
  const { headerName, width } = props
  const headersToCapsLock = ["Cytd", "Py", "pytd", "ttm"]

  const capitalizeMatchingWord = (sentence: string) => {
    // Split the sentence into words
    const words = sentence.split(/\s+/)
    // Iterate over each word in the sentence
    const capitalizedWords = words.map((word) => {
      // Check if the word exists in the headersToCapsLock array
      const matchIndex = headersToCapsLock.findIndex(
        (header) => header.toLowerCase() === word.toLowerCase(),
      )

      // If the word exists in headersToCapsLock, capitalize it
      if (matchIndex !== -1) {
        return word.toUpperCase()
      }

      // Otherwise, return the word as is
      return word
    })
    // Join the words back into a sentence
    return capitalizedWords.join(" ")
  }

  return (
    <BasicHeaderWrapper width={width}>
      <Typography textTransform={"capitalize"}>
        {capitalizeMatchingWord(headerName)}
      </Typography>
    </BasicHeaderWrapper>
  )
}

export default OpportunityHeader
